<template>
  <Modal :open="open" :close="close">
    <div class="px-10 py-5" :class="showCountDown && 'hidden'">
      <div>
        <p class="text-gray-500">Are you sure to publish the draft?</p>
        <div class="mt-6 flex justify-between">
          <button
            @click="handleConfirm"
            type="submit"
            class="inline-flex items-center bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-2 ease-linear transition-all duration-150"
          >
            Yes
          </button>
          <button
            @click="close"
            type="button"
            class="inline-flex items-center bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
          >
            No
          </button>
        </div>
      </div>
    </div>
    <div v-if="showCountDown" class="px-10 py-5">
      <img
        width="200"
        v-if="showCountDown"
        src="@/assets/imgs/321GO.gif"
        alt="31go"
      />
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Shared/Modal/Base";

export default {
  name: "DeleteConfirmation",
  data() {
    return {
      showCountDown: false
    };
  },
  components: {
    Modal
  },
  props: {
    close: {
      type: Function,
      required: true
    },
    open: {
      type: Boolean,
      required: true
    },
    handlePublish: {
      type: Function,
      required: true
    }
  },
  methods: {
    handleConfirm() {
      this.showCountDown = true;
      setTimeout(() => {
        this.handlePublish();
        this.showCountDown = false;
        this.close();
      }, 4000);
    }
  }
};
</script>
